import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Finyearmst, Purpose, TallyReceiptModel, Transaction, Txncategory } from '../../models/tallyentry-api-model';
import { getLocaleDateFormat } from '@angular/common';
import { UtilityService } from '../../services/utility-service';
import { DisplayDialogComponent } from '../display-dialog/display-dialog.component';

@Component({
  selector: 'app-pop-up',
  templateUrl: './pop-up.component.html',
  styleUrls: ['./pop-up.component.css']
})
export class PopUpComponent implements OnInit {
  public l_tallyReceiptModel: TallyReceiptModel = new TallyReceiptModel();
  public l_financialYear: Finyearmst = new Finyearmst();
  public l_transactionCategory: Txncategory = new Txncategory();
  public l_purpose: Purpose = new Purpose();
  public l_transaction: Transaction = new Transaction();
  public l_txndate: string = '';
  public l_createddate: string = '';
  public l_updateddate: string = '';
  public l_amountDisplay: string = '';

  constructor( 
    @Inject(MAT_DIALOG_DATA) public data: any,
    private l_UtilityService: UtilityService,
    private dialogRef: MatDialogRef<PopUpComponent>
  ) { }

  async ngOnInit(): Promise<void> {
    this.l_tallyReceiptModel = new TallyReceiptModel(this.data);
    this.l_financialYear = this.l_tallyReceiptModel.accountsHeader.finyearmst;
    this.l_transactionCategory = this.l_tallyReceiptModel.accountsHeader.txncategory;
    this.l_purpose = this.l_tallyReceiptModel.accountsHeader.purpose;
    this.l_transaction = this.l_tallyReceiptModel.accountsHeader.transaction;

    this.l_txndate = await this.lFN_ConvertDateFromSeconds(this.l_transaction.txnDate);
    this.l_createddate = await this.lFN_ConvertDateFromSeconds(this.l_tallyReceiptModel.createdDate);
    this.l_updateddate = await this.lFN_ConvertDateFromSeconds(this.l_tallyReceiptModel.updatedDate);

    this.l_amountDisplay = this.l_UtilityService.lFN_FormatCurrencyForDisplay(this.l_tallyReceiptModel.accountsHeader.amount);
  }

  async lFN_ConvertDateFromSeconds(l_numdate: number) {
    let date = new Date(l_numdate);
    let day = String(date.getDate()).padStart(2, '0');
    let month = String(date.getMonth() + 1).padStart(2, '0');
    let year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  lFN_OnClose() {
    this.dialogRef.close();
  }
}
